import { render, staticRenderFns } from "./NutrieducationDetail.vue?vue&type=template&id=671791bc&scoped=true&"
import script from "./NutrieducationDetail.vue?vue&type=script&lang=js&"
export * from "./NutrieducationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NutrieducationDetail.vue?vue&type=style&index=0&id=671791bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671791bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
